module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Extended-Medium.e8fa0fe6.eot";